import * as React from 'react';

import FileCode16 from './FileCode16';

export const fileCode16 = () => <FileCode16 />;

export default {
    title: 'Icon|Fill|FileCode16',
    component: FileCode16,
    parameters: {
        notes: "`import FileCode16 from 'box-ui-elements/es/icon/fill/FileCode16';`",
    },
};
